import { render, staticRenderFns } from "./JobDetailForm.vue?vue&type=template&id=76c96871&"
import script from "./JobDetailForm.vue?vue&type=script&lang=js&"
export * from "./JobDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./JobDetailForm.vue?vue&type=style&index=0&id=76c96871&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports